// extracted by mini-css-extract-plugin
export default {"section":"Messages_section__HsQDg","board":"Messages_board__VELBl","content":"Messages_content__CgHy8"};